import type { LegalSection } from './legalMeta';
import { LEGAL_META } from './legalMeta';

export const accountDeletionTitle = 'Account Deletion';

export const accountDeletionSections: LegalSection[] = [
  {
    id: 'in-app',
    title: 'Delete in the App (Recommended)',
    paragraphs: [
      `Open ${LEGAL_META.brandName} → Settings → Account → Delete account.`,
      'Confirm deletion. This permanently removes your profile, sign-in access, and associated posts and comments, subject to the retention notes below.',
      'To delete specific posts, comments, or profile fields without closing your account, see Delete Your Data on this site.',
    ],
  },
  {
    id: 'what-deleted',
    title: 'What Is Deleted',
    paragraphs: ['When you delete your account, we delete or de-identify:'],
    listItems: [
      'Your account credentials and profile (username, name, bio, photos).',
      'Posts and comments associated with your account.',
      'Social graph data such as follows tied to your account.',
    ],
  },
  {
    id: 'retention',
    title: 'What May Be Retained',
    paragraphs: [
      'Limited backups may persist for a short period for security and disaster recovery, then are purged according to our systems.',
      'We may retain minimal records where required by law, fraud prevention, or to resolve disputes.',
      'Content you shared externally (for example via share to another app) is not controlled by us after sharing.',
    ],
  },
  {
    id: 'apple-google',
    title: 'Sign in with Apple or Google',
    paragraphs: [
      `If you used Apple or Google sign-in, deleting your ${LEGAL_META.brandName} account removes your use of our service. Revocation of Apple tokens is handled as part of our deletion process where applicable.`,
    ],
  },
  {
    id: 'email-request',
    title: 'Cannot Access the App',
    paragraphs: [
      `Email ${LEGAL_META.contactEmail} from the address associated with your account with the subject “Account deletion request.” We will verify ownership and process deletion within a reasonable time.`,
    ],
  },
  {
    id: 'timeline',
    title: 'Processing Time',
    paragraphs: [
      'Deletion is processed as soon as practicable, usually within 30 days. You may need to sign out and reinstall to clear local tokens on your device.',
    ],
  },
];
